import '../utilities/css.js';
import '../draggable/css.js';
import '../droppable/css.js';
import '../resizable/css.js';
import '../inlineedit/css.js';
import '../sortable/css.js';
import '../contextmenu/css.js';
import './tabs.scss';